var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TermsOfServiceStage"},[_vm._v("\n  TERMS OF SERVICE PAGE\n")])}
var staticRenderFns = []

export { render, staticRenderFns }